import { render, staticRenderFns } from "./Trainers.vue?vue&type=template&id=ea37f0ac"
import script from "./Trainers.vue?vue&type=script&lang=js"
export * from "./Trainers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports